(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["key-holder"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__argusKeys) return; window.__argusKeys = true;
  function init(root) {
    var form = root.querySelector('[data-key-form]');
    var main = root.querySelector('[data-gal-main]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    function show(id) {
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === String(id);
        t.classList.toggle('is-active', on);
        if (on && main) { main.src = t.dataset.src; var im = t.querySelector('img'); if (im) main.alt = im.alt; }
      });
    }
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.mediaId); }); });
    if (!form) return;
    var data = form.querySelector('[data-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idIn = form.querySelector('[data-variant-id]');
    var price = form.querySelector('[data-price]');
    var add = form.querySelector('[data-add]');
    var addText = add ? add.textContent : '';
    form.addEventListener('change', function (e) {
      if (e.target.dataset.optIndex === undefined) return;
      var sel = [];
      form.querySelectorAll('input[data-opt-index]:checked').forEach(function (r) {
        sel[+r.dataset.optIndex] = r.value;
        var l = form.querySelector('[data-opt-label="' + r.dataset.optIndex + '"]'); if (l) l.textContent = r.value;
      });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (v) {
        idIn.value = v.id; if (price) price.textContent = v.price;
        if (add) { add.disabled = !v.available; add.textContent = v.available ? addText : 'Sold out'; }
        if (v.media) show(v.media);
      }
    });
  }
  function boot(s) { s.querySelectorAll('#keys').forEach(init); }
  if (document.readyState !== 'loading') boot(document); else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plate-kit"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.__argusPlate) return; window.__argusPlate = true;
  function init(root) {
    var form = root.querySelector('[data-plate-form]');
    if (!form) return;
    var data = form.querySelector('[data-variants]');
    var variants = data ? JSON.parse(data.textContent) : [];
    var idIn = form.querySelector('[data-variant-id]');
    var price = form.querySelector('[data-price]');
    var add = form.querySelector('[data-add]');
    var addText = add ? add.textContent : '';
    var box = form.querySelector('[data-custom-text]');
    var txt = form.querySelector('[data-upper]');
    var main = root.querySelector('[data-gal-main]');
    var thumbs = root.querySelectorAll('[data-gal-thumb]');
    function show(id) {
      thumbs.forEach(function (t) {
        var on = t.dataset.mediaId === String(id);
        t.classList.toggle('is-active', on);
        if (on && main) { main.src = t.dataset.src; var im = t.querySelector('img'); if (im) main.alt = im.alt; }
      });
    }
    function update() {
      var sel = [];
      form.querySelectorAll('input[data-opt-index]:checked').forEach(function (r) {
        sel[+r.dataset.optIndex] = r.value;
        var l = form.querySelector('[data-opt-label="' + r.dataset.optIndex + '"]'); if (l) l.textContent = r.value;
      });
      var v = variants.filter(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); })[0];
      if (v) {
        idIn.value = v.id; price.textContent = v.price;
        if (add) { add.disabled = !v.available; add.textContent = v.available ? addText : 'Sold out'; }
        if (v.media) show(v.media);
      }
      var custom = sel.indexOf('Custom text') !== -1;
      if (box) box.hidden = !custom;
      if (txt) { txt.disabled = !custom; txt.required = custom; }
    }
    form.addEventListener('change', function (e) { if (e.target.dataset.optIndex !== undefined) update(); });
    thumbs.forEach(function (t) { t.addEventListener('click', function () { show(t.dataset.mediaId); }); });
    if (txt) txt.addEventListener('input', function () { var p = txt.selectionStart; txt.value = txt.value.toUpperCase(); try { txt.setSelectionRange(p, p); } catch (err) {} });
  }
  function boot(s) { s.querySelectorAll('#plates').forEach(init); }
  if (document.readyState !== 'loading') boot(document); else document.addEventListener('DOMContentLoaded', function () { boot(document); });
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();

  } catch(e) { console.error(e); }
})();
})();
